import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const viewImg = require("./../assets/img/viewImg.png");
const backBtn = require("./../assets/img/back-btn.svg").default;

const ViewOneForm = () => {
  const [userData, setUserData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [images, setImages] = useState();
  const [status, setStatus] = useState();
  const [signImage, setSignImage] = useState();

  const { fileId } = useParams(); // Get the file name from route params

  useEffect(() => {
    // Retrieve user data from local storage
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    // Fetch file details using the specific file's name
    fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/${fileId}`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        let tempArray = [];
        tempArray.push(data.labels, data.input_values, data.created_at);
        setFileDetails(tempArray);
        setImages(data.images);
        setStatus(data.status);
        setSignImage(data.sign);
        // setFileName(data.data.title);
      })
      .catch((error) => {
        console.error("Error fetching file details:", error);
      });
  }, [fileId]);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewOne">
            <div className="viewOneLeft">
              <Link to="/view-forms">
                <img src={backBtn} alt="image" />
              </Link>
              <h3>View Form</h3>
            </div>
            {Number(status) === 0 ? (
              <div className="viewOneRight">
                <Link
                  to={{
                    pathname: `/edit-form/${fileId}`, // Use fileId here
                    state: { fileData: fileDetails }, // Pass fileDetails here if needed
                  }}
                  className="createFormBtn vwOneBtn iconNone"
                >
                  Edit Form
                </Link>
              </div>
            ) : null}
          </div>
          <div className="viewBox">
            <ul className="previewOne">
              {fileDetails && (
                <li>
                  <label>Order Date:</label>
                  <div className="dscFile">{fileDetails[2]}</div>
                </li>
              )}
              {fileDetails &&
                fileDetails[0] &&
                Object.entries(fileDetails[0]).map(([label, value]) =>
                  value !== "" && value !== "" ? (
                    <li key={label}>
                      <label>
                        {value === "Release notes"
                          ? "Job description and Notes"
                          : value}
                        :
                      </label>
                      <div className="dscFile">{fileDetails[1][label]}</div>
                    </li>
                  ) : null
                )}

              {images && images?.length > 0 ? (
                <li className="crteForm fulWid prvwImgBox">
                  <label>Images:</label>
                  {/* <div className="dscFile"> */}
                  <div className="dscFile">
                    <div className="image-preview">
                      {images.map((image, index) => (
                        <div key={index} className="image-container">
                          <img
                            src={`https://cliqestimatebuilder.com/waiver_admin/${image.image}`}
                            alt={`API Image ${index + 1}`}
                            className="upImg"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* </div> */}
                </li>
              ) : null}
              {signImage ? (
                <li className="crteForm fulWid prvwImgBox">
                  <label>Signature: </label>
                  {/* <div className="dscFile"> */}
                  <div className="dscFile">
                    <div className="image-preview">
                      <div className="image-container">
                        <img
                          src={`https://cliqestimatebuilder.com/waiver_admin/${signImage}`}
                          alt={`signed image`}
                          className="upImg"
                        />
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                </li>
              ) : null}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOneForm;
